
export enum CircleButtonSize {
  ExtraLarge = 'circle-icon-extra-large',
  Large = 'circle-icon-large',
  Medium = 'circle-icon',
  Small = 'circle-icon-small',
}

export enum ButtonSize {
  Large = 'button-large',
  Medium = 'button-medium',
  Small = 'button-small',
}

export enum ButtonType {
  Primary = 'btn-primary',
  Light = 'btn-light',
  Dark = 'btn-dark',
  OutlineLight = 'btn-outline-light',
  OutlineDark = 'btn-outline-dark',
  OutlinePrimary = 'btn-outline-primary',
  Disabled = 'btn-disabled'
}

export interface ButtonMetadata {
  type?: ButtonType;
  name?: string;
  title?: string;
  areaName?: string;
  actionName?: string;
  targetUrl?: string;
  analyticsTargetUrl?: string;
  productName?: string;
  paymentDueAmount?: string;
  componentName?: string;
  iconName?: string;
  disabled?: boolean;
  outline?: boolean;
  size?: ButtonSize | CircleButtonSize;
  analyticsTitle?: string;
  target?: string;
  entryPoint?: string;
}